import React, { Component } from 'react';
import { SERVER_URL } from './ServerConfig';
import { Modal, Button } from 'react-bootstrap';
import EmailValidator from 'email-validator';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class Members extends Component {
    notify = () => {
        toast.success("New member has been created!", {
            position: toast.POSITION.TOP_CENTER
        });
    };

    notifyDeleteMember = () => {
        toast.success("Member has been deleted!", {
            position: toast.POSITION.TOP_CENTER
        });
    };

    constructor(props) {
        super(props);

        this.state = {
            members : [],
            pendingAddMember : false,
            addMemberEmail : '',
            addMemberFirstName : '',
            addMemberLastName : '',
            addMemberPhone : '',
            addMemberMessage : '',
            addMemberPassword: '',
            addMemberConfirmPassword: '',
            pendingDeleteUser : false,
            deleteUser : null,
            deleteUserMessage : '',
        }

        this.handleOpenAddMemberDialog = this.handleOpenAddMemberDialog.bind(this);
        this.handleCloseAddMemberDialog = this.handleCloseAddMemberDialog.bind(this);
        this.handleAddMember = this.handleAddMember.bind(this);

        this.handleChangeMemberEmail = this.handleChangeMemberEmail.bind(this);
        this.handleChangeMemberFirstName = this.handleChangeMemberFirstName.bind(this);
        this.handleChangeMemberLastName = this.handleChangeMemberLastName.bind(this);
        this.handleChangeMemberPhone = this.handleChangeMemberPhone.bind(this);
        this.handleAddMemberPassword = this.handleAddMemberPassword.bind(this);
        this.handleAddMemberConfirmPassword = this.handleAddMemberConfirmPassword.bind(this);

        this.handleOpenDeleteUserDialog = this.handleOpenDeleteUserDialog.bind(this);
        this.handleCloseDeleteUserDialog = this.handleCloseDeleteUserDialog.bind(this);
        this.handleDeleteUser = this.handleDeleteUser.bind(this);
    }

    componentDidMount() {
        this.fetchMembers();
    }

    isOwner() {
        let user = this.props.user.payload.user;
        return user && user.member && user.member.mRole === 'owner';
    }

    fetchMembers() {
        let user = this.props.user.payload.user;
        let token = this.props.user.payload.token;
        let project = user.member.mProjectID;

        fetch(SERVER_URL + '/v1/projects/' + project._id + '/getMembers', {
            headers: {
                'x-access-token': token
            }
        })
            .then(response => {
                if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    return response.json();
                }
            })
            .then(data => {
                if (data.success) {
                    console.log(data.content);
                    this.setState({ members : data.content});
                }
            })
    }

    handleOpenDeleteUserDialog(e, user) {
        this.setState({ pendingDeleteUser: true, deleteUser: user, deleteUserMessage: "" });
    }

    getStatus(user) {
        let status = user.mStatus;
        if (status == 'active') {
            return (<span class="badge bg-success">ACTIVE</span>);
        } else {
            return (<span class="badge bg-danger">INACTIVE</span>);
        }
    }

    getActionItem(user) {
        if (!this.isOwner()) {
            return;
        }
        let role = user.mRole;
        if (role === 'member') {
            return (
                <td> <a href="#" className="btn btn-small btn-danger" onClick={e => this.handleOpenDeleteUserDialog(e, user)}><i className="fas fa-trash"></i></a></td>
            );
        } else {
            return (
                <td></td>
            )
        }
    }


    getMemberRow(member, idx) {
        return (
            <tr key={member._id}>
                <td><b>{member.mUserID.mFirstName + " " + member.mUserID.mLastName}</b></td>
                <td scope="row">
                    {member.mUserID.mEmail}
                </td>
                <td>
                    {member.mRole === 'owner' ? 'Owner' : 'Member'}
                </td>
                <td> {member.mUserID.mPhone}</td>
                {this.getActionItem(member)}
            </tr>
        )
    }

    getTableContent() {
        let members = this.state.members;
        return members.map((member, idx) => {
            return this.getMemberRow(member, idx);
        })
    }

    handleCloseDeleteUserDialog() {
        this.setState({ pendingDeleteUser: false, deleteUser: null });
    }

    handleDeleteUser() {
        let user = this.props.user.payload.user;
        let token = this.props.user.payload.token;
        let project = user.member.mProjectID;

        fetch(SERVER_URL + '/v1/projects/' + project._id + '/deleteMember', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': token
            },
            body: JSON.stringify({
                email: this.state.deleteUser.mUserID.mEmail,
            })
        }).then(response => response.json())
            .then(data => {
                console.log(data);
                if (data.success) {
                    this.notifyDeleteMember();
                    this.handleCloseDeleteUserDialog();
                    this.fetchMembers();
                } else {
                    this.setState({ addMemberMessage: data.message });
                }
            }).catch(err => {
                this.setState({ addMemberMessage: "Server is in maintenance" });
            });
    }

    getDeleteUserModal() {
        return (
            <Modal show={this.state.pendingDeleteUser} onHide={this.handleCloseDeleteUserDialog} animation={false} >
                <Modal.Header closeButton>
                    <Modal.Title>Delete user</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {"Do you want to delete this user?"}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="default" onClick={this.handleCloseDeleteUserDialog}>
                        No
                        </Button>
                    <Button variant="danger" onClick={this.handleDeleteUser}>
                        Yes
                        </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    getAddMemberModal() {
        return (
            <Modal show={this.state.pendingAddMember} onHide={this.handleCloseAddMemberDialog} animation={false} >
                <Modal.Header closeButton>
                    <Modal.Title>Add member</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="form-horizontal" >
                        <div className="text-center">
                            <p className="text-danger">{this.state.addMemberMessage}</p>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Email</label>
                            <div className="col-sm-9">
                                <input type="email" className="form-control" placeholder="example@gmail.com" value={this.state.addMemberEmail} onChange={this.handleChangeMemberEmail} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Password</label>
                            <div className="col-sm-9">
                                <input type="password" autoComplete="new-password" className="form-control" placeholder="" value={this.state.addMemberPassword} onChange={this.handleAddMemberPassword} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Confirm Password</label>
                            <div className="col-sm-9">
                                <input type="password" autoComplete="new-password" className="form-control" placeholder="" value={this.state.addMemberConfirmPassword} onChange={this.handleAddMemberConfirmPassword} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">First Name</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" placeholder="Nguyen" value={this.state.addMemberFirstName} onChange={this.handleChangeMemberFirstName} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Last Name</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" placeholder="Van" value={this.state.addMemberLastName} onChange={this.handleChangeMemberLastName} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Phone</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" placeholder="0911222333" value={this.state.addMemberPhone} onChange={this.handleChangeMemberPhone} />
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="default" onClick={this.handleCloseAddMemberDialog}>
                        Close
                        </Button>
                    <Button variant="success" onClick={this.handleAddMember} className={this.canAddMemberClass()}>
                        Add
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    handleChangeMemberEmail(event) {
        let value = event.target.value;
        this.setState({ addMemberMessage: '', addMemberEmail : value });
    }

    handleChangeMemberFirstName(event) {
        let value = event.target.value;
        this.setState({ addMemberMessage: '', addMemberFirstName : value });
    }

    handleChangeMemberLastName(event) {
        let value = event.target.value;
        this.setState({ addMemberMessage: '',  addMemberLastName : value });
    }

    handleChangeMemberPhone(event) {
        let value = event.target.value;
        this.setState({ addMemberMessage: '',  addMemberPhone : value });
    }

    handleAddMemberPassword(event) {
        let value = event.target.value;
        this.setState({ addMemberMessage: '',  addMemberPassword : value });
    }

    handleAddMemberConfirmPassword(event) {
        let value = event.target.value;
        this.setState({ addMemberMessage: '',  addMemberConfirmPassword : value });
    }

    canAddMemberClass() {
        if (!this.state.addMemberEmail || !this.state.addMemberFirstName || !this.state.addMemberLastName || !this.state.addMemberPhone
            || !this.state.addMemberPassword || !this.state.addMemberConfirmPassword) {
            return "disabled";
        }
        if (this.state.addMemberPassword !== this.state.addMemberConfirmPassword) {
            return "disabled";
        }
    }

    handleAddMember() {
        if (!EmailValidator.validate(this.state.addMemberEmail)) {
            this.setState({ addMemberMessage : 'Email is not valid' });
            return;
        }
        if (this.state.addMemberPassword.length < 8) {
            this.setState({ addMemberMessage : 'Password must be at least 8 characters' });
            return;
        }

        let user = this.props.user.payload.user;
        let token = this.props.user.payload.token;
        let project = user.member.mProjectID;

        fetch(SERVER_URL + '/v1/projects/' + project._id + '/createMember', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': token
            },
            body: JSON.stringify({
                email: this.state.addMemberEmail,
                password: this.state.addMemberPassword,
                firstName : this.state.addMemberFirstName,
                lastName : this.state.addMemberLastName,
                phone : this.state.addMemberPhone
            })
        }).then(response => response.json())
            .then(data => {
                console.log(data);
                if (data.success) {
                    this.notify();
                    this.setState({ pendingAddMember : false});
                    this.fetchMembers();
                } else {
                    this.setState({ addMemberMessage: data.message });
                }
            }).catch(err => {
                this.setState({ addMemberMessage: "Server is in maintenance" });
            });
    }

    handleOpenAddMemberDialog() {
        this.setState({ pendingAddMember : true, addMemberEmail : '', addMemberFirstName : '', addMemberLastName : '', addMemberPhone : '', addMemberMessage : ''});
    }
    
    handleCloseAddMemberDialog(event) {
        this.setState({ pendingAddMember: false });
    }

    getButtonBar() {
        if (this.isOwner()) {
            return (<div className="row d-flex justify-content-end mr-1">
                <div>
                    <button type="button" className="btn btn-block btn-success btn-md" onClick={this.handleOpenAddMemberDialog}>Add</button>
                </div>
            </div>)
        }
        return (
            <div></div>
        );
    }

    getActionColumn() {
        if (this.isOwner()) {
            return (
                <th scope="col"></th>
            )
        }
    }

    render() {
        return (
            <div className="content-wrapper">
                <section className="content-header" />
                <section className="content">
                    <div className="container-fluid">
                        {this.getButtonBar()}
                        <div className="table-responsive mt-4">
                            <table className="table table-bordered table-hover dataTable" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <th scope="col">Name</th>
                                        <th scope="col">Email</th>
                                        <th scope="col">Role</th>                                        
                                        <th scope="col">Phone</th>
                                        {this.getActionColumn()}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.getTableContent()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>
                {this.getAddMemberModal()}

                {this.getDeleteUserModal()}
                <ToastContainer />
            </div>
        )
    }
}